import dayjs from "dayjs";

export const getNumberOfBookingNights = ({
  checkIn,
  checkOut,
}: {
  checkIn?: string | Date;
  checkOut?: string | Date;
}) => {
  if (!checkIn || !checkOut) return 0;

  const nights = dayjs(checkOut)
    .startOf("day")
    .diff(dayjs(checkIn).startOf("day"), "day");

  return nights < 0 ? 0 : nights;
};
